import { ChangeRequestDiffReportDataV2 } from '@kaiizen/kai-pro-api';
import { computeDiff } from '@kaiizen/kai-reports';
import { useMemo } from 'react';
import { useScanEditingContextSlice } from './ScanEditingContext';
import { useScopeReportDataCore } from './useScopeReportDataCore';

export const useScopeReportData = () => {
  const { scan } = useScanEditingContextSlice(['scan']);

  const {
    reportData,
    isLoading,
    isError: isReportDataError,
    error,
  } = useScopeReportDataCore();

  const {
    isAvailable: isBaselineAvailable,
    isError: isBaselineError,
    reportData: baselineReportData,
    isLoading: isBaselineLoading,
    error: baselineError,
  } = useScopeReportDataCore(true);

  const diffReportData = useMemo((): ChangeRequestDiffReportDataV2 | undefined => {
    if (!isBaselineAvailable || !baselineReportData || !reportData) {
      return undefined;
    }

    const changedLineItems = computeDiff(
      reportData.scopeLineItems,
      baselineReportData.scopeLineItems,
    );

    if (changedLineItems.length === 0) {
      return undefined;
    }

    const currentTotalCost = reportData.overviewData.totalProjectCost || 0;
    const baselineTotalCost = baselineReportData.overviewData.totalProjectCost || 0;
    const totalDifference = currentTotalCost - baselineTotalCost;

    return {
      overviewData: {
        currentTotalCost,
        baselineTotalCost,
        totalDifference,
      },
      scopeLineItems: changedLineItems,
    };
  }, [scan, reportData, baselineReportData]);

  return {
    reportData,
    diffReportData,
    isLoading: isLoading || isBaselineLoading,
    isError: isReportDataError || isBaselineError,
    error: error ?? baselineError,
  };
};
